import React, {useEffect} from "react";
import { BrowserRouter as Router,Switch, Route, Redirect,  useLocation} from "react-router-dom";
// import { connect } from 'react-redux';
import "./pages_main/homepage/assets/css/fontawesome-all.min.css"


import ResetPasswordConfPage from './pages_auth/ResetPasswordConfPage';

import ActivatePage from './pages_auth/ActivatePage';
import Login from "./pages_auth/Login";
// Error page
import Page404 from './pages_main/page404/Page404';

import PrivacyPage from "./pages_main/privacy-policy/PrivacyPage";
import CookiePage from './pages_main/cookie-policy/CookiePage';
import TermsPageMobile from './pages_main/terms/TermsPageMobile';

import { CookieConsentAll } from './common/cookie-consent/CookieConsentAll';

import HomePageSimple from "./pages_main/homepage/simple/HomePageSimple";
import  TermsFooter  from "./pages_main/homepage/simple/TermsFooter";
import DeleteAccount from "./pages_main/privacy-policy/DeleteAccount";


const Base = ({ }) => {
  const { pathname, hash, key } = useLocation();

  const location = useLocation();

  useEffect(() => {
    // if not a hash link, scroll to top
    if (hash === '') {
      window.scrollTo(0, 0);
    }
    // else scroll to id
    else {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView();
        }
      }, 0);
    }
  }, [pathname, hash, key]); // do this on route change



  // let isHome = (location.pathname=='/' || location.pathname=='/home/')
  let isHome =  ['/','/foogeapp/login/','/home/','/download/','/download','/404']?.includes(location.pathname)
  let isDownload =  ['/download/','/download']?.includes(location.pathname)
  // let isContact =  ['/contact/','/contact']?.includes(location.pathname) 
  let isTerms =  ['/terms','/terms-mobile' , '/privacy-policy','/cookie-policy' ,
  '/terms/','/terms-mobile/' , '/privacy-policy/','/cookie-policy/' ]?.includes(location.pathname) 

  return(
    <>
    <CookieConsentAll/> 



        <Router>
          <Switch>

            <Redirect exact from='/' to='/home'/>

              <Route exact path='/home' component={HomePageSimple} /> 
              <Route exact path='/request-deletion' component={DeleteAccount} /> 

              <Route exact path='/terms' component={TermsPageMobile} /> 
              <Route exact path='/terms-mobile' component={TermsPageMobile} /> 
             
              <Route exact path='/privacy-policy' component={PrivacyPage} /> 
              <Route exact path='/cookie-policy' component={CookiePage} /> 
              <Route exact path='/download' component={HomePageSimple}/> 
              <Route exact path='/open' component={HomePageSimple}/> 
              <Route exact path='/password/reset/confirm/:uid/:token' component={ResetPasswordConfPage} />
              <Route exact path='/activate/:uid/:token' component={ActivatePage} />
              <Route exact path='/foogeapp/login' component={Login} />



              <Route path='/404' component={Page404} />
          <Redirect to='/404' />
          </Switch>

        </Router>
        



        {
        isTerms ?
      <div >
    <TermsFooter isXs={true}/>
  </div>
  :null
        }

</>
        );
  }

  export default Base;

  /* 
  // If you ever need to re-enable Redux connect for this component later:
  const mapStateToProps = state => ({
  });
  
  export default connect(mapStateToProps, {})(Base);
  */